<template>
  <a-modal
    :visible="visible"
    :title="$i18n.t('page_sync')"
    :width="500"
    :destroyOnClose="true"
    :maskClosable="false"
    :bodyStyle="{ paddingTop: '8px' }"
    :confirmLoading="submitLoading"
    :okText="$i18n.t('page_sync')"
    @ok="submit"
    @cancel="cancel"
  >
    <div class="sync-Tree">
      <a-tree
        v-model="checkedKeys"
        checkable
        :checkedKeys="checkedKeys"
        :expandedKeys="expendKeys"
        :tree-data="treeData"
        @expand="expandKey"
        @check="onSelect"
      >
      </a-tree>
    </div>
  </a-modal>
</template>

<script>
import { DataTreeNode } from '@/utils/array'
import {
  WorkStationGroupServiceProxy,
  WorkStationWorkingConditionParamSettingServiceProxy
} from '@/service-proxies/app-v2/workStation.service-proxies'

const wswcpssp = new WorkStationWorkingConditionParamSettingServiceProxy()
const wsgsp = new WorkStationGroupServiceProxy()

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      treeData: [],
      submitLoading: false,
      checkedKeys: [],
      expendKeys: [],
      workStatoinItems: []
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.getTreeList()
        }
      }
    }
  },
  methods: {
    getTreeList() {
      this.workStatoinItems = []
      this.expendKeys = []
      this.checkedKeys = []
      wsgsp.workStationGroupList().then((res) => {
        if (res) {
          const keys = []
          const data = res.reduce((total, value) => {
            const key = value.id + '-' + value.parentId
            total.push({
              ...value,
              key: key
            })
            return total
          }, [])
          this.treeData = DataTreeNode.arrayToTree(data)
          this.treeData.map((item) => {
            if (item.children && item.children.length) {
              item.children.map((t) => {
                this.getTreeSelect(t, keys)
              })
            } else {
              if (this.defaultNumberChecked < 5) {
                keys.push(item.key)
                this.defaultNumberChecked = this.defaultNumberChecked + 1
              }
            }
          })
          this.workStatoinItems = data
          this.checkedKeys = keys
        }
      })
    },
    getTreeSelect(data, arr) {
      if (data.children && data.children.length) {
        data.children.map((m) => {
          this.getTreeSelect(m, arr)
        })
      } else {
        if (this.defaultNumberChecked < 5) {
          arr.push(data.key)
          this.defaultNumberChecked = this.defaultNumberChecked + 1
        }
      }
      return arr
    },
    setWorkStationList() {
      const recheckKeys = []
      this.workStatoinItems.map((res) => {
        if (
          this.checkedKeys.includes(this.addKeyId(res)) &&
          !recheckKeys.includes(res.id) &&
          !res.isGroup
        ) {
          recheckKeys.push(res.id)
        }
      })
      return recheckKeys
    },
    addKeyId(item) {
      const key = item.id + '-' + item.parentId
      return key
    },
    submit() {
      const ids = this.setWorkStationList()
      if (ids && ids.length) {
        const body = {
          settingId: this.record.detail ? this.record.detail.id : '',
          workStationIds: ids
        }
        this.submitLoading = true
        wswcpssp
          .syncWorkStationParamSetting(body)
          .then(() => {
            this.$message.success(this.$t('sync_success'))
            this.submitLoading = false
            this.reload()
            this.$emit('reload')
          })
          .catch(() => {
            this.submitLoading = false
          })
      }
    },
    cancel() {
      this.reload()
      this.$emit('close')
    },
    reload() {
      this.treeData = []
      this.submitLoading = false
      this.checkedKeys = []
      this.expendKeys = []
      this.workStatoinItems = []
    },
    expandKey(value) {
      this.expendKeys = value
    },
    onSelect(value) {
      console.log(value)
      this.checkedKeys = value
    }
  }
}
</script>

<style scoped>
.sync-Tree {
  height: 500px;
  overflow-y: auto;
}
</style>
